import { useMapEvents } from 'react-leaflet';
import { Dispatch, SetStateAction } from 'react';

interface MapClickEventsProps {
  setLatitude: Dispatch<SetStateAction<string | null>>;
  setLongitude: Dispatch<SetStateAction<string | null>>;
  setAddress: Dispatch<SetStateAction<string | null>>;
}

function MapClickEvents({
  setLatitude,
  setLongitude,
  setAddress,
}: MapClickEventsProps) {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;

      setLatitude(String(lat));
      setLongitude(String(lng));

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=jsonv2`
        );
        if (response.ok) {
          const data = await response.json();
          setAddress(data.display_name);
        } else {
          console.error('Erro ao buscar endereço:', response.statusText);
          setAddress(null);
        }
      } catch (error) {
        console.error('Erro de requisição:', error);
        setAddress(null);
      }
    },
  });

  return null;
}

export default MapClickEvents;
